import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import classes from './ServersModal.module.css';

const serversModal = (props) => {
  const serverList = props.servers.map((server) => {
    const active = props.selectedServer
      ? props.selectedServer.DefaultFor === server.DefaultFor
      : process.env.NODE_ENV === server.DefaultFor.toLowerCase();
    return (
      <div onClick={() => props.selectServer(server)} className={classes.Server} key={server.Id}>
        <div>
          {server.Name}
          {active === true ? <FontAwesomeIcon icon="check" className={classes.ServerInUse} /> : null}
        </div>
      </div>
    );
  });
  return (
    <div className={classes.ServersContainer}>
      <div className={classes.ServerListHeader}>
        <h4>Select API Server</h4>
        <p>Select a server to use for API calls.</p>
      </div>
      {props.servers.length > 0 ? serverList : <p>No Servers Available</p>}
      <div className={classes.Cancel} onClick={props.toggle}>
        <p>Cancel</p>
      </div>
    </div>
  );
};

export default serversModal;
